import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, Typography } from "@material-ui/core";
import { SectionDefinition } from "api/factories/form.factory";
import { TextField } from "components";
import { SectionDefinitionValue } from "components/SchemaProvider";

export const NumberField = ({ name, translation, value }: SectionDefinition<SectionDefinitionValue>) => {
    const { control, errors } = useFormContext();

    return (
        <FormControl fullWidth={true}>
            <Controller
                defaultValue={value}
                name={name}
                control={control}
                error={!!errors[name]}
                label={translation}
                as={<TextField variant="outlined" type="number" />}
            />
            {errors[name] && (
                <Typography variant="body1" color="error">
                    {errors[name].message}
                </Typography>
            )}
        </FormControl>
    );
};
